export const APPOINTMENT_STATE_CONFIG = {
  libre:      { color: '#546e7a', muiColor: 'default', label: 'Libre / Bloqueado' },
  pendiente:  { color: '#ef5350', muiColor: 'error',   label: 'Pendiente' },
  confirmado: { color: '#ffb300', muiColor: 'warning', label: 'Confirmado' },
  cancelado:  { color: '#616161', muiColor: 'default', label: 'Cancelado' },
  ausente:    { color: '#ff6d00', muiColor: 'warning', label: 'Ausente' },
  atendido:   { color: '#1565c0', muiColor: 'info',    label: 'Atendido' },
  ocupado:    { color: '#ef5350', muiColor: 'error',   label: 'Pendiente' }, // legacy
};

export const APPOINTMENT_STATE_OPTIONS = [
  { value: 'pendiente',  label: 'Pendiente',         hint: 'turno asignado, sin confirmar' },
  { value: 'confirmado', label: 'Confirmado',        hint: 'el paciente confirmó que viene' },
  { value: 'cancelado',  label: 'Cancelado',         hint: 'no viene, slot disponible' },
  { value: 'ausente',    label: 'Ausente',           hint: 'no vino sin avisar' },
  { value: 'atendido',   label: 'Atendido',          hint: 'consulta realizada' },
  { value: 'libre',      label: 'Libre / Bloqueado', hint: 'sin paciente asignado' },
];
